<template>
  <div>

    <!-- <div class="container-fluid">
      <v-row class="app-course">
        <v-col cols="12" sm="12" md="12"></v-col></v-row></div> -->

    <div class="container-fluid title-page">
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <h2>Associar usuários ao cursos</h2>
        </v-col>
      </v-row>

    </div>
    <v-card class="ma-10" style="padding: 24px;">

      <v-progress-linear v-if="loadingCourses" :indeterminate="true"></v-progress-linear>

      <v-row v-else>
        <v-col cols="12" xs="12">
          <h3>Selecione o curso</h3>
        </v-col>

        <v-col cols="12" xs="12" sm="6">
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" class="card-user" v-for="(course, $index) in coursesUsers" :key="$index">

              <div @click="selectCourse(course, $index)" :key="$index" ref="cursos">
                <v-img :src="course.image" aspect-ratio="2"></v-img>
                <h4>{{ course.title }}</h4>
              </div>

            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" xs="12" sm="6" v-if="courseSelect">
          <v-layout row wrap>

            <v-col cols="12" xs="12" class="user-input">
              <h4>{{ courseSelect.title }}</h4>

              <div v-if="courseSelect.gradeTypes && courseSelect.gradeTypes.length">
                <v-col cols="12" xs="12">
                  <v-chip v-for="(grade, $index) in courseSelect.gradeTypes" :key="$index">{{ grade.name }}</v-chip>
                </v-col>
                <v-col cols="12" xs="12">
                  <v-btn color="info" @click="sendToTeachers" :disabled="loading" :loading="loading">Enviar convite aos professores</v-btn>
                </v-col>
              </div>
              <v-col cols="12" xs="12">
                <v-textarea
                  @keyup="addUserEvent"
                  solo
                  label="Digite os emails de usuários"
                  v-model="textUsers"
                  ref="textarea"
                  :disabled="loading"
                >
                </v-textarea>
                <!--
                                  <template v-if="usersToInvite.length" v-slot:prepend-inner>
                                    <v-chip close v-for="(user, $index) in usersToInvite" :key="$index" v-model="usersToInvite[$index].active">{{ user.email }}</v-chip>
                                  </template>
                -->
              </v-col>
              <v-btn dark color="green" @click="addUserList" :disabled="loading" :loading="loading">Adicionar</v-btn>
            </v-col>

            <v-col cols="12" xs="12" class="user-list">
              <v-card>
                <v-card-title class="py-0 px-0">
                  <v-toolbar dark>

                    <v-toolbar-title>Usuários</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <input :class="showSearchUsers ? 'active' : 'disabled'" placeholder="Sua pesquisa" ref="searchUsers" v-model="searchUsers">
                    <v-btn icon>
                      <v-icon @click="clickSearch">search</v-icon>
                    </v-btn>
                  </v-toolbar>
                </v-card-title>
                <v-card-text class="py-0 px-0">
                  <v-list style="max-height: 300px" class="scroll-y">

                    <v-list-tile v-for="(item, $index) in listUsers" :key="$index">
                      <v-list-tile-action>
                        <v-icon class="delete" @click="deleteUser($index)">close</v-icon>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.email }} <span v-if="item.name">({{ item.name }})</span></v-list-tile-title>
                      </v-list-tile-content>
                      <v-tooltip bottom v-if="item.pendingInvite || item.invited">
                        <template v-slot:activator="{ on }">
                          <v-icon :color="item.invited ? 'deep-purple accent-4' : 'grey'" v-on="on">check</v-icon>
                        </template>
                        <span v-if="item.invited">Usuário associado ao curso</span>
                        <span v-if="item.pendingInvite">Usuário foi convidado, mas ainda não entrou ao curso</span>
                      </v-tooltip>
                    </v-list-tile>
                  </v-list>
                </v-card-text>
                <v-card-actions v-if="showSendInvites">
                  <v-btn :loading="loading" :disabled="loading" color="warning" @click="removeInvitationsNotSent">Remover convites não enviados</v-btn>
                  <v-divider></v-divider>
                  <v-btn :loading="loading" :disabled="loading" color="info" @click="sendInvites">Enviar convites</v-btn>
                </v-card-actions>
              </v-card>

            </v-col>

          </v-layout>
        </v-col>

      </v-row>

    </v-card>
    <v-snackbar
      v-model="showAlert"
      :top="true"
      :color="colorAlert"
    >
      {{ textAlert }}
      <v-btn
        color="black"
        flat
        @click="showAlert = false">
        Fechar
      </v-btn>
    </v-snackbar>

  </div>

</template>

<script>
import { defaultCourseImage, swalConfirm } from '@/helpers'

const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
export default {
  name: 'UserCourseAssociate',
  data () {
    return {
      loadingCourses: true,
      loading: false,
      showAlert: false,
      textAlert: '',
      colorAlert: 'error',
      coursesUsers: [],
      usersToInvite: [],
      invalidEmails: [],
      gradeTypes: [],
      textUsers: '',
      courseSelect: '',
      groupUsers: [],
      listUsers: [],
      groups: [],
      usersFromGroups: [],
      loadingGroupUsers: false,
      showSearchUsers: false,
      searchUsers: '',
      // newListUsers: []
    }
  },
  watch: {
    usersToInvite (val) {
      this.listUsers = val
    },
    searchUsers (val) {
      if (val.length >= 3) {
        this.newListUsers = this.usersToInvite.filter(user => {
          return (user.email.toLowerCase().indexOf(val.toLowerCase()) !== -1) || (user.name && user.name.toLowerCase().indexOf(val.toLowerCase()) !== -1)
        })
      } else {
        this.newListUsers = JSON.parse(JSON.stringify(this.usersToInvite))
      }
    },
    invalidEmails (val) {
      if (val.length) {
        if (val.length === 1) {
          this.textAlert = `O email "${val[0]}" é inválido`
        } else {
          this.textAlert = `Os emails "${val.join('", "')}" são inválidos`
        }

        this.showAlert = true
        this.invalidEmails = []
      }
    }
  },
  computed: {
    showSendInvites: function () {
      for (let i = 0; i < this.usersToInvite.length; i++) {
        if (!this.usersToInvite[i].invited && !this.usersToInvite[i].pendingInvite) {
          return true
        }
      }

      return false
    },
    newListUsers: {
      get: function () {
        return JSON.parse(JSON.stringify(this.usersToInvite))
      },
      set: function (newValue) {
        this.listUsers = newValue
      }
    }
  },
  methods: {
    clickSearch () {
      this.showSearchUsers = !this.showSearchUsers

      if (this.showSearchUsers) {
        this.$refs.searchUsers.focus()
      } else {
        this.searchUsers = ''
      }
    },
    addUserEvent (e) {
      if (e.key === 'Enter') {
        this.textUsers = this.textUsers.substr(0, this.textUsers.length - 1)

        return this.addUserList()
      }
    },
    removeInvitationsNotSent () {
      this.usersToInvite = this.usersToInvite.filter(user => {
        return (user.invited || user.pendingInvite)
      })
    },

    addUserList () {
      if (!this.textUsers && !this.groupUsers.length) {
        return false
      }

      let users = []

      if (this.textUsers) {
        users = this.textUsers.split(';')
      }

      if (this.groupUsers.length) {
        for (let i = 0; i < this.groupUsers.length; i++) {
          for (let k = 0; k < this.usersFromGroups.length; k++) {
            if (this.groupUsers[i] === this.usersFromGroups[k].key) {
              for (let j = 0; j < this.usersFromGroups[k].users.length; j++) {
                users.push(this.usersFromGroups[k].users[j].email)
              }
            }
          }
        }
      }

      users = users.filter((item, index) => users.indexOf(item) === index)

      for (let i = 0; i < users.length; i++) {
        let email = users[i].replace(/^\s+|\s+$/gm, '') // remove espaços no fim e começo da string

        let indexEmailAssociated = this.usersToInvite.findIndex(user => {
          return user.email === email && user.invited
        })

        let indexEmailNotSent = this.usersToInvite.findIndex(user => {
          return user.email === email && !user.invited && !user.pendingInvite
        })

        if (indexEmailAssociated === -1 && indexEmailNotSent === -1) {
          if (email.match(mailFormat)) {

            let indexEmail = this.usersToInvite.findIndex(user => {
              return user.email === email && user.pendingInvite
            })

            if (indexEmail !== -1) {
              swalConfirm({
                title: `Um novo convite será enviado para ${email}`,
                text: 'Confirma a ação?',
                type: 'info',
                btnConfirmText: 'Confirmar',
                btnConfirmColor: '#00C853'
              }).then(() => {
                this.usersToInvite.unshift({ email, active: true })
              })
            } else {
              this.usersToInvite.unshift({ email, active: true })
            }
          } else {
            this.invalidEmails.unshift(email)
          }
        }
      }

      this.textUsers = ''

      return false
    },
    // getCourses () {
    //   this.loadingCourses = true
    //   this.loading = true
    //
    //   this.axios.post('/user/course/my', {
    //     "options": {
    //       "sortBy": "createdAt",
    //       "sortDesc": true,
    //       "page": 1,
    //       "itemsPerPage": 10
    //     }
    //   }).then(response => {
    //     if (response.data.success) {
    //       this.axios.get('/user/grade-types/combo').then(({ data }) => {
    //         if (data.success) {
    //           this.coursesUsers = response.data.courses.map(c => {
    //             if (!c.image) {
    //               c.image = defaultCourseImage
    //             }
    //
    //             if (c.gradeTypes && c.gradeTypes.length) {
    //               c.gradeTypes = c.gradeTypes.map(gradeId => {
    //                 const index = data.combo.findIndex(c => c._id === gradeId)
    //
    //                 if (index !== -1) {
    //                   return data.combo[index]
    //                 }
    //               })
    //             }
    //
    //             return c
    //           })
    //         }
    //       })
    //     }
    //   }).catch(console.error).finally(() => {
    //     this.loading = false
    //     this.loadingCourses = false
    //   })
    // },
    getCourses () {
      this.loadingCourses = true
      this.loading = true

      this.axios.post('/user/course/my', {
        'options': {
          'sortBy': 'createdAt',
          'sortDesc': true,
          'page': 1,
          'itemsPerPage': 10
        }
      }).then(response => {
        if (response.data.success) {
          this.coursesUsers = response.data.courses.map(c => {
            if (!c.image) {
              c.image = defaultCourseImage
            }

            return c
          })
        }
      }).catch(console.error).finally(() => {
        this.loading = false
        this.loadingCourses = false
      })
    },

    sendToTeachers () {
      this.loading = true

      this.axios.get(`/course-invite/teacher/${this.courseSelect._id}`).then(response => {
        if (response.data.success) {
          this.$swal('Sucesso', 'Os convites estão sendo enviados', 'success').then(() => {
            this.getCourses()

            this.groupUsers = []

            this.usersToInvite = this.usersToInvite.map(user => {
              if (!user.invited && !user.pendingInvite) {
                user.pendingInvite = true
              }

              return user
            })
          })
        }
      }).catch(console.error).finally(() => {
        this.loading = false
      })
    },

    sendInvites () {
      this.loading = true

      const emails = this.usersToInvite.filter(user => {
        return (!user.invited && !user.pendingInvite)
      }).map(user => user.email)

      /* eslint-disable */
      axios.post('course-invite', { courseId: this.courseSelect._id, emails }).then(response => {
        if (response.data.success) {
          this.$swal('Sucesso', 'Os convites estão sendo enviados', 'success').then(() => {
            this.getCourses()

            this.groupUsers = []

            this.usersToInvite = this.usersToInvite.map(user => {
              if (!user.invited && !user.pendingInvite) {
                user.pendingInvite = true
              }

              return user
            })
          })
        }
      }).catch(console.error).finally(() => {
        this.loading = false
      })

    },

    deleteUser (index) {
      const userInvited = this.usersToInvite[index]

      if (userInvited._id) {
        let title = '',
          url = '',
          params = {
            courseId: this.courseSelect._id
          }

        if (userInvited.invited) { // usuário ja associado
          title = 'Confirma exclusão do usuário do curso?'

          url = '/user/associate-course/remove'
          params.userId = userInvited._id
        }

        if (userInvited.pendingInvite) { // usuário apenas convidado
          title = 'Confirma exclusão do convite do usuário?'

          url = '/course-invite/remove'
          params.inviteId = userInvited._id
        }

        swalConfirm({
          title,
          text: 'Esta ação não poderá ser desfeita',
          type: 'warning'
        }).then(() => {
          axios.post(url, params).then(response => {
            if (response.data.success) {
              this.textAlert = 'Excluído com sucesso'
              this.colorAlert = 'success'

              this.usersToInvite.splice(index, 1)
            } else {
              this.textAlert = 'Houve um erro'
              this.colorAlert = 'error'
            }
          }).catch(() => {
            this.textAlert = 'Houve um erro'
            this.colorAlert = 'error'
          }).finally(() => {
            this.showAlert = true
          })
        })
      } else {
        this.usersToInvite.splice(index, 1)
      }
    },
    selectCourse (item, i) {
      this.$refs.cursos.forEach(el => {
        el.classList.remove('active')
        el.classList.add('disabled')
      })
      this.$refs.cursos[i].classList.toggle('active')

      let usersToInvite = []

      if (item.usersCourse && item.usersCourse.length) {
        usersToInvite = usersToInvite.concat(item.usersCourse.map(user => {
          user.invited = true

          return user
        }))
      }

      if (item.invites && item.invites.length) {
        usersToInvite = usersToInvite.concat(item.invites.map(user => {
          user.pendingInvite = true

          return user
        }))
      }

      this.usersToInvite = usersToInvite.sort((a, b) => {
        return String(a.email).localeCompare(String(b.email))
      })

      this.courseSelect = item
    }
  },
  created () {
    this.getCourses()
    // this.getUsersCategories()
  }
}
</script>
